// Master JS for the about page

// Expanding sections and the "Read More" reveal are wired up globally by site-v3.js.

// Clicking the photo stack cycles which image sits on top. The stacking order and the
// slide-out animation come from data-swap-index / data-swap-current-index in
// _image-swap.scss, which only defines three positions.
const desktop = window.matchMedia("(min-width: 600px)");

for (const stack of document.querySelectorAll("[data-image-swap]")) {
    const items = stack.querySelectorAll(":scope > *");
    if (!items.length) continue;

    items.forEach((item, index) => { item.dataset.swapIndex = index; });
    stack.dataset.swapItemCount = items.length;
    // -1 matches none of the scss selectors, so the stack starts in its resting order
    stack.dataset.swapCurrentIndex = -1;

    stack.addEventListener("click", () => {
        // Only cycles on desktop, where the images are laid out as an overlapping stack
        if (!desktop.matches) return;
        stack.dataset.swapCurrentIndex = (Number(stack.dataset.swapCurrentIndex) + 1) % items.length;
    });
}
